import React from 'react';
import profilePic from '../../../assets/profilepic.jfif'
import './AdminNav.scss'
import logo from '../../../assets/cropped-logo_white.png'


const AdminNav = () => {


    return (
        <nav className='admin-nav'>
            <div className="logo-search d-flex">
                <div className="logo">
                    <img src={logo} alt="" />
                    <h1>LVZCONNECT</h1>
                </div>
                

                <div className="hamburger">
                    <div className="line"></div>
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <form action="" className="search">
                    <input type="text" name='admin-search' placeholder='Search...'/>
                    <button type='submit' className="search-icon">
                        <i class="fas fa-search"></i>
                    </button>
                    
                </form> 
            </div>
            

            <div className="end">
                <i class="fas fa-expand"></i>
                <img src={profilePic} alt="" />
            </div>
        </nav>
    )
}

export default AdminNav